// extracted by mini-css-extract-plugin
export default {"avatar":"index_avatar_3Pw-M","large":"index_large_L8c7b","normal":"index_normal_pgL-9","small":"index_small_0Gm-4","unset":"index_unset_Nzwzi","circle":"index_circle_WmYKc"};